import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';

const CabeceraDestino = ({ lang, destino, ruta }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <>
            <section className="u-clearfix u-image u-valign-bottom-md u-valign-middle-lg u-valign-middle-sm u-section-1" id="sec-dc6f" data-image-width="2070" data-image-height="1148" style={{ backgroundImage: destino.imagen_principal.length > 0 ? `url(${ruta}/destinos/${destino.id}/${destino.imagen_principal[0].imagen})` : `url(/images/web/bedloop-nofoto.png` }}>
                <h1 className={`u-align-center u-custom-font u-font-oswald u-text u-text-body-alt-color u-text-default u-title u-text-1 ${(destino.id == 47) ? 'u-text-grey-80' : ""}`} data-animation-name="customAnimationIn" data-animation-duration="1000" data-animation-delay="0" data-animation-out="0">{destino.elnombre.toUpperCase()}</h1>
                {(destino.id == 47) ?
                    <h1 className="u-align-center u-custom-font u-font-oswald u-text u-text-default u-text-grey-80 u-title u-text-2" data-animation-name="customAnimationIn" data-animation-duration="1000" data-animation-delay="0" data-animation-out="0">{t("por mar")}</h1>
                    :
                    ""
                }
                <div className={`u-container-align-center-lg u-container-align-center-md u-container-align-center-sm u-container-align-center-xl u-container-style u-group u-opacity u-opacity-60 u-radius u-shape-round u-group-1 ${(destino.id == 40) ? 'u-gradient' : 'u-shading'}`} data-animation-name="customAnimationIn" data-animation-duration="2000" data-animation-delay="200" data-animation-out="0">
                    <div className={`u-container-layout u-valign-middle-lg u-container-layout-1 ${(destino.id != 47) ? "u-valign-middle-sm u-valign-middle-xs" : ""}`} style={destino.id === 47 ? { alignContent: "center" } : undefined}>
                        <h1 className={`u-align-center u-custom-font u-font-montserrat u-text ${(destino.id != 40) ? 'u-text-body-alt-color' : ''}  u-title u-text-${(destino.id == 47) ? '3' : '2'} `}>
                            {t(destino.id2)}
                        </h1>
                    </div>
                </div>
                <a href={"/" + preidioma + t("contacto")} className="u-align-center u-border-none u-btn u-btn-round u-button-style u-hover-feature u-hover-white u-radius u-white u-btn-1" title="Solicitar propuesta personalizada" target="_blank" style={{ marginLeft: "auto", marginRight: "auto", fontWeight: "700" }}> {t("Solicitar presupuesto").toUpperCase()}</a>
            </section >
            <section className="u-align-center u-clearfix u-container-align-center u-section-2" id="block-12">
                <div className="u-clearfix u-sheet u-valign-middle u-sheet-1">
                    <div className="data-layout-selected u-clearfix u-expanded-width u-layout-wrap u-layout-wrap-1">
                        <div className="u-layout">
                            <div className="u-layout-row">
                                <div className="u-container-style u-image u-layout-cell u-size-30 u-image-1" data-image-width="1900" data-image-height="1236" style={{ backgroundImage: destino.imagenes.length > 1 ? `url(${ruta}/destinos/${destino.id}/${destino.imagenes[1].imagen})` : `url(/images/web/bedloop-nofoto.png` }}>
                                    <div className="u-container-layout u-container-layout-1"></div>
                                </div>
                                <div className="u-container-align-center u-container-style u-layout-cell u-size-30 u-layout-cell-2">
                                    <div className="u-container-layout u-container-layout-2">
                                        <h3 className="u-align-center u-text u-text-1">{destino.elnombre}</h3>
                                        {ReactHtmlParser(destino.eltexto)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h1 className="u-align-center u-custom-font u-font-montserrat u-text u-text-body-alt-color u-title u-text-3"></h1>
                </div>
                <style data-mode="XXL">
                    {`
                @media (max-width: 0px) {
        .u-section-2 .u-sheet-1 {
            min-height: 613px;
        }
        .u-section-2 .u-text-1 {
            width: 758px;
            min-height: 478px;
            height: auto;
            margin-top: 60px;
            margin-bottom: 60px;
            margin-left: auto;
            margin-right: auto;
        }
        .u-section-2 .u-text-3 {
            position: absolute;
            bottom: 10px;
            width: auto;
            height: auto;
        }
        .u-block-08e8-25 {
            background-image: linear-gradient(0deg, rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url("images/90fc53c9.svg");
            background-position: 50% 50%;
        }
        .u-block-08e8-26 {
            padding-top: 30px;
            padding-bottom: 30px;
            padding-left: 60px;
            padding-right: 60px;
        }
        .u-block-08e8-32 {
            margin-top: 0;
            margin-bottom: 0;
            margin-left: auto;
            margin-right: auto;
        }
        .u-block-08e8-33 {
            width: 409px;
            margin-top: 20px;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 0;
        }
        .u-block-08e8-34 {
            border-style: none;
            font-weight: 700;
            text-transform: uppercase;
            font-size: 0.875rem;
            letter-spacing: 1px;
            background-image: none;
            margin-top: 30px;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 0;
        }
        .u-block-08e8-35 {
            background-image: linear-gradient(0deg, rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url("images/90fc53c9.svg");
            background-position: 50% 50%;
        }
        .u-block-08e8-36 {
            padding-top: 30px;
            padding-bottom: 30px;
            padding-left: 60px;
            padding-right: 60px;
        }
        .u-block-08e8-37 {
            margin-top: 0;
            margin-bottom: 0;
            margin-left: auto;
            margin-right: auto;
        }
        .u-block-08e8-38 {
            width: 409px;
            margin-top: 20px;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 0;
        }
        .u-block-08e8-39 {
            border-style: none;
            font-weight: 700;
            text-transform: uppercase;
            font-size: 0.875rem;
            letter-spacing: 1px;
            background-image: none;
            margin-top: 30px;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 0;
        }
        .u-block-08e8-16 {
            width: 38px;
            height: 38px;
            background-image: none;
            left: -58px;
            position: absolute;
            right: auto;
        }
        .u-section-2 .u-container-layout-2 {
            width: 38px;
            height: 38px;
            background-image: none;
            left: auto;
            position: absolute;
            right: -58px;
        }
                `}
                </style>
            </section>
        </>
    );
}

export default CabeceraDestino;
